import { render, staticRenderFns } from "./ChangeSubjectViewType.vue?vue&type=template&id=3a3ba046"
import script from "./ChangeSubjectViewType.vue?vue&type=script&lang=js"
export * from "./ChangeSubjectViewType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports